import bancontact from "@Images/logo-bancontact.png";
import mastercard from "@Images/logo-mastercard.png";
import paypal from "@Images/logo-paypal.png";
import sofort from "@Images/logo-sofort.png";
import visa from "@Images/logo-visa.png";
import mastercardLogo from "@Images/mastercard.png";
import paypalLogo from "@Images/paypal.png";
import visaLogo from "@Images/visa.png";
import { PaymentMethod } from "@Types/cart";

export const generic = "cheerz_CheckoutPaymentStep_error_generic";
const expiredCard = "cheerz_CheckoutPaymentStep_error_cc_expired";
const invalidCard = "cheerz_CheckoutPaymentStep_error_cc_invalid";
const refusedPayment = "cheerz_CheckoutPaymentStep_error_payment_refused";
const invalidNumber = "cheerz_CheckoutPaymentStep_error_cc_number_invalid";
const invalidMonth = "cheerz_CheckoutPaymentStep_error_cc_month_invalid";
const invalidYear = "cheerz_CheckoutPaymentStep_error_cc_year_invalid";
const invalidCvc = "cheerz_CheckoutPaymentStep_error_cc_cvv_invalid";

interface ErrorMessages {
  [key: string]: string;
}

export const errorMessages: ErrorMessages = {
  "card.acquirer-failed": generic,
  "card.bad-track-data": invalidCard,
  "card.blacklisted": generic,
  "card.contact-bank": refusedPayment,
  "card.currency-unsupported": generic,
  "card.declined": generic,
  "card.do-not-honor": generic,
  "card.dont-retry": generic,
  "card.duplicate": generic,
  "card.exceeded-activity-limits": refusedPayment,
  "card.exceeded-limits": refusedPayment,
  "card.exceeded-withdrawal-limit": refusedPayment,
  "card.expired": expiredCard,
  "card.expired-3ds": generic,
  "card.failed-3ds": generic,
  "card.failed-avs": generic,
  "card.failed-avs-address": generic,
  "card.failed-avs-postal": generic,
  "card.failed-cvc": invalidCvc,
  "card.failed-cvc-and-avs": generic,
  "card.invalid": invalidCard,
  "card.invalid-account": refusedPayment,
  "card.invalid-address": generic,
  "card.invalid-cvc": invalidCvc,
  "card.invalid-expiry-date": invalidCard,
  "card.invalid-month": invalidMonth,
  "card.invalid-name": invalidCard,
  "card.invalid-number": invalidNumber,
  "card.invalid-pin": invalidCard,
  "card.invalid-year": invalidYear,
  "card.invalid-zip": generic,
  "card.issuer-down": generic,
  "card.issuer-failed": generic,
  "card.issuer-not-found": generic,
  "card.lost": generic,
  "card.maximum-attempts": refusedPayment,
  "card.missing-3ds": generic,
  "card.missing-cvc": invalidCvc,
  "card.missing-expiry": invalidCard,
  "card.missing-number": invalidNumber,
  "card.needs-authentication": generic,
  "card.network-failed": generic,
  "card.no-action-taken": generic,
  "card.no-money": refusedPayment,
  "card.not-activated": generic,
  "card.not-authorized": generic,
  "card.not-registered": generic,
  "card.not-supported": generic,
  "card.please-retry": generic,
  "card.possible-fraud": generic,
  "card.processing-error": generic,
  "card.revoked": generic,
  "card.revoked-all": generic,
  "card.security-violation": generic,
  "card.stolen": generic,
  "card.test": generic,
  "card.type-not-supported": generic,
  "card.unsupported-3ds": generic,
  "customer.cancelled": generic,
  "gateway.declined": generic,
  "gateway.not-allowed": generic,
  "gateway.validation-error": generic,
  "payment.declined": generic,
};

export const getInputError = (code: string): string | undefined => {
  const cvcInputErrors = ["card.failed-cvc", "card.invalid-cvc", "card.missing-cvc"];
  const dateInputErrors = [
    "card.expired",
    "card.expired-3ds",
    "card.invalid-expiry-date",
    "card.invalid-month",
    "card.invalid-year",
    "card.missing-expiry",
  ];
  const nameInputErrors = ["card.invalid-name"];
  const numberInputErrors = ["card.invalid-number", "card.missing-number"];

  if (new Set(cvcInputErrors).has(code)) {
    return "cvc";
  } else if (new Set(dateInputErrors).has(code)) {
    return "date";
  } else if (new Set(nameInputErrors).has(code)) {
    return "name";
  } else if (new Set(numberInputErrors).has(code)) {
    return "number";
  } else {
    return undefined;
  }
};

export const getPaymentMethodLogos = (method: PaymentMethod): string[] => {
  switch (method) {
    case "bancontact":
      return [bancontact];
    case "cc":
      return [visa, mastercard];
    case "paypal":
      return [paypal];
    case "sofort":
      return [sofort];
    default:
      return [];
  }
};

export const paymentTypes = [
  { name: "Mastercard", src: mastercardLogo },
  { name: "Visa", src: visaLogo },
  { name: "Paypal", src: paypalLogo },
];
